import i18next from "i18next";

export const renderValidatorMessage = (item: any, t: (key: string, options?: any) => string): string => {
  if (!item.messageCode) {
    return item.message || "";
  }
  var key = "validators.message." + item.messageCode;
  var params = item.messageParams || {};
  var translated = t(key, params);
  if (translated === key || translated.includes("{{")) {
    return item.message || "";
  }
  return translated;
};
